import { requestOfferFromHistoryActions } from './actions';
import { AuthRequiredError } from '../../errors/AuthRequiredError';
import { fetchOfferFromHistory } from '../../services/offersHistory/fetchOfferFromHistory';
import { TThunkAction } from '../../types/redux';

export const getOfferFromHistory =
  (params: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    dispatch(requestOfferFromHistoryActions.request());

    try {
      const data = await fetchOfferFromHistory(context, params);

      dispatch(
        requestOfferFromHistoryActions.success({
          id: params.cianId,
          data,
        }),
      );
    } catch (e) {
      if (e instanceof AuthRequiredError) {
        dispatch(requestOfferFromHistoryActions.authFailure());
      } else {
        dispatch(requestOfferFromHistoryActions.failure());
      }

      throw e;
    }
  };

interface IParams {
  cianId: number;
}
